import { Locale } from '@interdan/public-ui';

export const API_URL = process.env.PRICE_LIST_PUBLIC_API_URL || '';
export const APP_INSIGHTS_INSTRUMENTATION_KEY = process.env.PRICE_LIST_PUBLIC_APP_INSIGHTS_INSTRUMENTATION_KEY || '';
export const GTM_ID = process.env.PRICE_LIST_PUBLIC_GTM_ID || '';
export const CLOUD_NAME = process.env.PRICE_LIST_PUBLIC_CLOUD_NAME || '';
export const LOCALE = process.env.PRICE_LIST_PUBLIC_LOCALE as Locale;
export const WIDGET_URL = process.env.PRICE_LIST_PUBLIC_WIDGET_URL || '';
export const RETAIL_WISMO_URL = process.env.PRICE_LIST_PUBLIC_RETAIL_WISMO_URL || '';
